import { render, staticRenderFns } from "./AddFilteringTabModal.vue?vue&type=template&id=38def13c&scoped=true&"
import script from "./AddFilteringTabModal.vue?vue&type=script&lang=js&"
export * from "./AddFilteringTabModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFilteringTabModal.vue?vue&type=style&index=0&id=38def13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38def13c",
  null
  
)

export default component.exports